import { Modal } from "antd";
import { ProductionItemForm } from "./ProductionItemForm";
import { ProductionItemAddbyCount } from "./ProductionItemAddbyCount";
import { ProductionItemAddbyList } from "./ProductionItemAddbyList";

const ProductionModal = ({
  isOpenModal,
  title,
  setIsOpenModal,
  productionRefetch,
  modalType,
  LicenseNo,
}) => {
  return (
    <div className="container-fluid mx-auto ">
      <Modal
        open={isOpenModal}
        closable={false}
        onCancel={() => setIsOpenModal(false)}
        footer={null}
        width={580}
        centered
        title={title}
        destroyOnClose
      >
        {modalType === "prodution" ? (
          <ProductionItemForm
            type={"add"}
            isModalForm={true}
            onCancel={() => setIsOpenModal(false)}
            productionRefetch={productionRefetch}
          />
        ) : modalType === "addByCount" ? (
          <ProductionItemAddbyCount
            isModalForm={true}
            onCancel={() => setIsOpenModal(false)}
            productionRefetch={productionRefetch}
            LicenseNo={LicenseNo}
          />
        ) : modalType === "addByList" ? (
          <ProductionItemAddbyList
            isModalForm={true}
            onCancel={() => setIsOpenModal(false)}
            productionRefetch={productionRefetch}
            LicenseNo={LicenseNo}
          />
        ) : null}
      </Modal>
    </div>
  );
};

export default ProductionModal;
